import {api} from './api';
import analyticsConstants from './analytics-constants';

const ANALYTICS_ENDPOINT = 'internal/event';

type AnalyticsConstants = typeof analyticsConstants;
export type AnalyticsConstant = AnalyticsConstants[keyof AnalyticsConstants];

/*
 * Service class which acts as an interface for clients to track events
 * across various platforms.
 */
export class NutAnalyticsClient {
    EVENTS: AnalyticsConstants;

    constructor() {
        this.EVENTS = analyticsConstants;
    }

    track(event: AnalyticsConstant, properties: any = {}) {
        const payload = {
            event,
            properties,
        } as const;

        // TODO: Ensure this has {headers: {'Content-Type': 'application/json'}}
        return api.post(ANALYTICS_ENDPOINT, payload);
    }
}
